export const IMG_URL = 'https://hqo.imgix.net/';
